import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import initGsapScrollState from "../triggers/gsapScrollState";
import initGsapAos from "../triggers/gsapAos";
import initGsapUnveil from "../triggers/gsapUnveil";
import initGsapSticker from "../triggers/gsapSticker";
import initGsapOdometer from "../triggers/gsapOdometer";
import initHorizontalSections from "../triggers/gsapHorizontalSections";
import initGsapHeroSection from "../triggers/gsapHeroSection";
import initGsapPropertyCards from "../triggers/gsapPropertyCards";
import initGsapFullscreenPagesCta from "../triggers/gsapFullscreenPagesCta";
import initGsapFullscreenPagesCtaV2 from "../triggers/gsapFullscreenPagesCtaV2";
import initGsapFullscreenTeamCards from "../triggers/gsapFullscreenTeamCards";
import initGsapStickyCta from "../triggers/gsapStickyCta";
import initGsapStickyVerticalSections from "../triggers/gsapStickyVerticalSections";
import initGsapSectionDrawer from "../triggers/gsapSectionDrawer";
import initGsapStickySidebar from "../triggers/gsapStickySidebar";

export default function initGsapTriggers() {
    // 1. Initialize all triggers
    initGsapScrollState();
    initGsapAos();
    initGsapStickySidebar();
    initGsapSticker();
    initGsapOdometer();
    initHorizontalSections();
    initGsapHeroSection();
    initGsapPropertyCards();
    initGsapFullscreenPagesCta();
    initGsapFullscreenPagesCtaV2();
    initGsapFullscreenTeamCards();
    initGsapStickyCta();
    initGsapStickyVerticalSections();
    initGsapUnveil();
    initGsapSectionDrawer();
    
    // 2. Global ScrollTrigger Configuration
    ScrollTrigger.config({
        autoRefreshEvents: "visibilitychange,DOMContentLoaded,load,resize",
        ignoreMobileResize: true
    });

    // 3. Robust Refresh Strategy
    const refreshTriggers = () => {
        ScrollTrigger.refresh();
    };

    // Refresh when fonts are ready
    document.fonts.ready.then(refreshTriggers);

    // Refresh immediately and after delays to ensure layout is settled
    refreshTriggers();
    setTimeout(refreshTriggers, 100);
    setTimeout(refreshTriggers, 500);
    setTimeout(refreshTriggers, 1000);

    // Handle Back/Forward Cache (BFCache)
    window.addEventListener("pageshow", (event) => {
        if (event.persisted) {
            refreshTriggers();
        }
    });

    // Initial refresh
    requestAnimationFrame(refreshTriggers);

    // Watch for dynamic content changes
    if (window.ResizeObserver) {
        const resizeObserver = new ResizeObserver(() => {
            gsap.delayedCall(0.1, refreshTriggers);
        });

        const dynamicElements = document.querySelectorAll('.read-smore, .horizontal-sections-track, .property-description');
        dynamicElements.forEach(el => resizeObserver.observe(el));
    }
}
